import React from 'react';

const RotationTriangleIcon = ({ flipHorizontal = false }) => (
  <svg
    width="2.3em"
    height="1.6em"
    viewBox="0 -16 64 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <g transform={flipHorizontal ? 'translate(64 0) scale(-1 1)' : undefined}>
      <path
        d="M1 3H38.5V23L1 3Z"
        transform="translate(0 26) scale(1 -1)"
        fill="inherit"
        stroke="inherit"
        strokeWidth="2.5"
        strokeLinejoin="round"
      />
      <path
        d="M43 -14.5V23H63L43 -14.5Z"
        fill="none"
        stroke="inherit"
        strokeWidth="2.5"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default RotationTriangleIcon;

export const HorizontallyFlippedRotationTriangleIcon = (props) => (
  <RotationTriangleIcon {...props} flipHorizontal />
);

const FlipTrianglePair = () => (
  <>
    <path
      d="M29.75 -14.75V26.5H9.75L29.75 -14.75Z"
      fill="inherit"
      stroke="inherit"
      strokeWidth="2.5"
      strokeLinejoin="round"
    />
    <path
      d="M34.25 -14.75V26.5H54.25L34.25 -14.75Z"
      fill="none"
      stroke="inherit"
      strokeWidth="2.5"
      strokeLinejoin="round"
    />
  </>
);

export const HorizontalFlipIcon = () => (
  <svg
    width="2.3em"
    height="1.6em"
    viewBox="0 -16 64 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <FlipTrianglePair />
  </svg>
);

export const VerticalFlipIcon = () => (
  <svg
    width="2.3em"
    height="1.6em"
    viewBox="0 -16 64 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <g transform="rotate(-90 32 6)">
      <FlipTrianglePair />
    </g>
  </svg>
);

export const ResetPositionIcon = () => (
  <svg
    width="2.3em"
    height="1.6em"
    viewBox="0 -16 64 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M25.5 -14.75V26.5H5.5L25.5 -14.75Z"
      fill="none"
      stroke="inherit"
      strokeWidth="2.5"
      strokeLinejoin="round"
    />
    <path
      d="M38.5 -14.75V26.5H58.5L38.5 -14.75Z"
      fill="none"
      stroke="inherit"
      strokeWidth="2.5"
      strokeLinejoin="round"
    />
    <path
      d="M32 -14.75V26.5"
      stroke="inherit"
      strokeWidth="2.5"
      strokeDasharray="5 3"
    />
  </svg>
);
